export const toggleSelectNoneClass = (isResizing) => {
  const body = document.querySelector('body');
  if (body) {
    if (isResizing) body.classList.add('select-none');
    else {
      body.classList.remove('select-none');
    }
  }
};
